module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-summary"
  }, [_c('h1', [_vm._v("月汇总报表")]), _c('month-select', {
    attrs: {
      "start": _vm.date_start,
      "end": _vm.date_end
    },
    on: {
      "update:start": function($event) {
        _vm.date_start = $event
      },
      "update:end": function($event) {
        _vm.date_end = $event
      }
    }
  }), _c('table', {
    staticClass: "ui celled structured table fixed olive"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.data), function(row, irow) {
    return _c('tr', {
      class: {
        summary: irow === _vm.data.length - 1
      }
    }, _vm._l((row), function(value, icol) {
      return _c('td', {
        staticClass: "right aligned",
        class: {
          bold: icol === 10 || icol === 0, negative: (value || "").startsWith("-") && value !== "-"
        }
      }, [_vm._v(_vm._s(value))])
    }))
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "center aligned"
  }, [_vm._v("房号")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("住户")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("租金")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("押金")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("预定金")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("管理费")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("冷水")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("热水")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("电费")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("其他")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("汇总")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e917a64a","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/reports/Month.vue
// module id = 537
// module chunks = 0